<template>
  <div v-if="screenShow">
    <div class="top-info">
      <div class="large-title">
        驾年华
      </div>
      <div class="small-title">
        WELCOME TO DABAOJIA
      </div>
    </div>
    <div class="bottom-logo">
      <img src="@/assets/images/logo-160x220.png"/>
    </div>
    <div class="bottom-button" @click="goTo(goToUrl)">进入</div>
    <div class="bottom-button-skin"></div>
    <div class="index-bg"></div>
  </div>
</template>

<script>

export default {
  computed: {
  },
  components: {
  },
  data () {
    return {
      goToUrl: 'login',
      login: false,
      screenShow: false
    }
  },
  watch: {
  },
  mounted () {
    // this.$store.dispatch('setUserInfo', {username: '186****1861', mobile: '186****1861'})
    /*
    console.log(this.$store.state.token);
    console.log(this.$store.state.userInfo.mobile);
    */
    /*
    console.log(this.$store.state.token);
    this.$store.dispatch('setToken', 'AAAA')
    console.log(this.$store.getters.token);
    this.$store.dispatch('setToken', '111')
    console.log(this.$store.getters.token);
    */
    this.pageInit()
  },
  methods: {
    pageInit() {
      let screenShow = localStorage.getItem('screenShow');
      if (screenShow) {
        this.screenShow = false;
      } else {
        this.screenShow = true;
      }
      this.checkLogin()
    },
    // 验证登录
    checkLogin () {
      let params = {}
      this.$api.user.checkLogin(params).then((res) => {
        console.log(res.data)
        if (res.data.code == 1) {
          // 已登录跳转
          this.goToUrl = '/user/center'
        }
        if (this.screenShow == false) {
          if (res.data.code == 1) {
            this.goTo('/user/center')
          } else {
            this.goTo('/login')
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 页面跳转
    goTo (path) {
      localStorage.setItem('screenShow', '1');
      this.$router.push(path);
    },
  }
};
</script>

<style lang="scss">
  @import "@/assets/css/style.scss";
</style>
